import { BlockUIService }                  from 'ng-block-ui';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable }                      from '@angular/core';
import { UIRouter }                        from '@uirouter/core';

import { ApiService }                 from '../../app-lite/api/api.service';
import { AzureSsoService }            from '../../app-lite/azure-sso/azure-sso.service';
import { SessionModel }               from '../../app-lite/sessions/models/session';
import { SessionService }             from '../../app-lite/sessions/session.service';
import { STATUSCODES }                from '../../app-lite/api/api.status-codes.constant';
import { SubscriptionService }        from '../../app-lite/subscriptions/subscription.service';
import { TwoFactorAuthSettingsModel } from '../two-factor-auth/typings/two-factor-auth.settings';
import { UserModel }                  from '../../app-lite/users/models/user';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private _STATUSCODES = STATUSCODES;

  constructor (
    private apiService         : ApiService,
    private azureSsoService    : AzureSsoService,
    private blockUIService     : BlockUIService,
    private router             : UIRouter,
    private sessionService     : SessionService,
    private subscriptionService: SubscriptionService
  ) {}

  login ( user : UserModel ) : Promise<any> {
    return this.apiService.post('/sessions/workshop', user, null, null, {
        verbose: true
      })
      .catch(( response : HttpErrorResponse ) => {
        return this.azureSsoService.isSsoRequiredForLogin(response)
          ? this.azureSsoService.getSessionUrl(user)
            .then(url => {
              window.location.assign(url);

              return Promise.reject(response.error);
            })
          : Promise.reject(response.error);
      })
      .then(( response : HttpResponse<any> ) => response.body)
      .then(( session : SessionModel ) => this.handleSession(session, user));
  }

  loginWithGoogle ( code : string, redirectUri : string ) : Promise<any> {
    return this.apiService.post('/sessions/google', {
      code        : code,
      redirect_uri: redirectUri
    })
    .then(( session : SessionModel ) => this.handleSession(session));
  }

  loginWithGoogleCredential ( credential : string ) : Promise<any> {
    return this.apiService.post('/sessions/google', {
      credential: credential
    })
    .then(( session : SessionModel ) => this.handleSession(session));
  }

  loginWithTwoFactorAuth ( settings : TwoFactorAuthSettingsModel ) : Promise<any> {
    return this.apiService.post('/sessions/submit_otp', settings, null, null)
      .then(( session : SessionModel ) => this.handleSession(session));
  }

  loginWithXero ( queryString : string ) : Promise<any> {
    return this.apiService.get(`/sessions/xero${ queryString }`)
    .then(( session : SessionModel ) => this.handleSession(session));
  }

  handleSession ( session : SessionModel, user : UserModel = { username: session.username } ) : Promise<any> {
    if ( session.two_factor_auth_required ) {
      this.sessionService.setKey('user', {
        id: session.user_id,
        ...user
      });

      this.router.stateService.go('app.two-factor-auth-login');

      return;
    }

    return this.sessionService.handleSessionLogin(session, user)
    .catch(( error : HttpErrorResponse ) => {
      if ( error.status === this._STATUSCODES.paymentRequired ) {
        this.blockUIService.resetGlobal();

        return this.subscriptionService.reactivate(session);
      }

      return Promise.reject(error);
    });
  }
}
